import * as React from "react";
import styled from "styled-components";
import { dropBoxFieldCss } from "../styles";
import { Text, IconButton } from "../../../elements";
import { select, useSelect } from "@hubper/theme";
import { IconName } from "../../../elements/Icon";
import posed from "react-pose";

const Base = posed(styled.div<{ stretch?: boolean }>`
  ${dropBoxFieldCss};
  width: ${p => (p.stretch ? "100%" : null)};
`)({
  enter: {
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 40
    }
  },
  exit: {
    opacity: 0,
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 40
    }
  }
});

export const Image = styled.div`
  width: 90px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${select.space(3)};
  padding-right: ${select.space(6)};
  flex-grow: 1;
  position: relative;
`;

const IconRight = styled(IconButton)`
  position: absolute;
  right: ${select.space(3)};
  top: 50%;
  transform: translateY(-50%);
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  image?: string;
  fileName: string;
  fileType?: string;
  icon?: IconName;
  onIconClick?: () => void;
  stretch?: boolean;
};

function FileInfo(
  {
    style,
    className,
    image,
    fileName,
    fileType,
    icon = "delete",
    onIconClick,
    stretch
  }: Props,
  ref: any
) {
  const { space } = useSelect();
  const [state, setState] = React.useState(false);

  React.useEffect(() => {
    setState(true);
  }, []);

  return (
    <Base
      ref={ref}
      pose={state ? "enter" : "exit"}
      animateOnMount
      style={style}
      stretch={stretch}
      className={className}
    >
      {image && (
        <Image>
          <img src={image} />
        </Image>
      )}
      <Content>
        <Text
          fw="heavy"
          fs={0}
          c={["grey", 8]}
          style={{ display: "block", marginBottom: space(0) }}
        >
          {fileName}
        </Text>
        {fileType && (
          <Text fs={-1} c={["grey", 4]}>
            {fileType}
          </Text>
        )}
        {icon && <IconRight onClick={onIconClick} name={icon} />}
      </Content>
    </Base>
  );
}

export default React.forwardRef(FileInfo);
